import { Icon } from '../common';
import type { ListState } from './filterTypes';

export interface BookingsErrorProps {
  message?: string;
  // The Type in force (viewings-in-the-bookings-list): a failed viewings read
  // must not be described as a bookings one.
  kind?: ListState;
  onRetry?: () => void;
}

const NOUN: Record<ListState, string> = { all: 'bookings and viewings', booking: 'bookings', viewing: 'viewings' };

// AC4 error state — net-new (Maya Gap 2). The fetch failed. Retrying a
// read is not a mutation, so the retry button is allowed under AC5.
export function BookingsError({ onRetry, kind = 'booking' }: BookingsErrorProps) {
  const noun = NOUN[kind];
  return (
    <div className="bookings-error" role="alert">
      <span className="bookings-error-icon">
        <Icon name="alert-triangle" size={22} />
      </span>
      <div className="bookings-error-headline">Couldn&rsquo;t load {noun}</div>
      <p className="bookings-error-msg">
        Something went wrong fetching your {noun}. Check your connection and try again.
      </p>
      {onRetry && (
        <button type="button" className="bookings-error-action" onClick={onRetry}>
          Try again
        </button>
      )}
    </div>
  );
}
